import { useQuery } from "@tanstack/react-query";
import { MaintenanceSettingsService } from "../../../services/maintenance-settings.service";
import { QUERY_CONSTANTS } from "../../queryKeys";

export const useGetServiceAvailabilityQuery = () => {
  return useQuery<number, Error>({
    queryKey: [QUERY_CONSTANTS.GET_SERVICE_AVAILABILITY],
    queryFn: () => MaintenanceSettingsService.getServiceAvailability().then((res) => res.data),
    refetchInterval: 30000, // 30 seconds
  });
};
